export enum OnboardingIndustry {
  B2B = `B2B / SaaS`,
  Consumer = `Consumer`,
  Social = `Social`,
  Media = `Media`,
  Gaming = `Gaming`,
  Education = `Education`,
  Healthcare = `Healthcare`,
  ECommerce = `E-Commerce`,
  Agency = `Agency`,
  Finance = `Finance`,
  Marketplace = `Marketplace`,
  Other = `Other`,
}

export const INDUSTRY_EVENTS = {
  b2b: {
    name: OnboardingIndustry.B2B,
    events: [`Sign Up`, `Page View`, `Request Demo`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  consumer: {
    name: OnboardingIndustry.Consumer,
    events: [`Sign Up`, `Page View`, `Create Item`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  social: {
    name: OnboardingIndustry.Social,
    events: [`Sign Up`, `Page View`, `Engage`, `Share`],
    templates: [`Company KPIs`, `Feature Launch`, `Lifecycle Cohort`],
  },
  media: {
    name: OnboardingIndustry.Media,
    events: [`Sign Up`, `Content View`, `Share`, `Purchase Subscription`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  gaming: {
    name: OnboardingIndustry.Gaming,
    events: [`Sign Up`, `Start Level`, `Finish level`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  education: {
    name: OnboardingIndustry.Education,
    events: [`Sign Up`, `Start Course`, `Finish Module`, `Finish Course`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  healthcare: {
    name: OnboardingIndustry.Healthcare,
    events: [`Sign Up`, `Complete Search`, `Schedule Appointment`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  ecommerce: {
    name: OnboardingIndustry.ECommerce,
    events: [`View Item`, `Add to Cart`, `View Cart`, `Purchase Completed`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  agency: {
    name: OnboardingIndustry.Agency,
    events: [`Sign Up`, `Page View`],
    templates: [`Company KPIs`, `GA Replacement`, `Marketing KPIs`],
  },
  finance: {
    name: OnboardingIndustry.Finance,
    events: [`Sign Up`, `Select Bank`, `Funded Account`, `Transaction`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  marketplace: {
    name: OnboardingIndustry.Marketplace,
    events: [`Sign Up`, `Page View`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
  other: {
    name: OnboardingIndustry.Other,
    events: [`Sign Up`, `Page View`],
    templates: [`Company KPIs`, `Feature Launch`, `GA Replacement`, `Lifecycle Cohort`],
  },
};

export type IndustryKey = keyof typeof INDUSTRY_EVENTS;
